import React from 'react';
import { LandingPage } from './components/LandingPage';
export function App() {
  return <main data-id="element-0">
      <LandingPage data-id="element-1" />
    </main>;
}